import React from 'react';

const AboutSection = () => (
  <section className="about">
    <div className="content">
      <h3>We deliver on technology leadership...</h3>
      <p>
        We are a company based in Portugal shaping businesses around the world.
        BST supports its activity in a skills-formed team and a vast partner
        network across the globe.
      </p>
      <p>
        Our goal is to generate a broad core of highly specialized skills through
        which we respond with quality and rigor to the challenges posed by each
        project and each organization.
      </p>
    </div>
    <div className="illustration">
      <img src="about.png" />
    </div>
  </section>
);

export default AboutSection;